var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_498_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70828 0H1.45828C0.654144 0 0 0.654144 0 1.45828V5.20828C0 6.01257 0.654144 6.66672 1.45828 6.66672H7.70828C8.51257 6.66672 9.16672 6.01257 9.16672 5.20828V1.45828C9.16672 0.654144 8.51257 0 7.70828 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70828 8.33203H1.45828C0.654144 8.33203 0 8.98618 0 9.79047V18.5405C0 19.3446 0.654144 19.9987 1.45828 19.9987H7.70828C8.51257 19.9987 9.16672 19.3446 9.16672 18.5405V9.79047C9.16672 8.98618 8.51257 8.33203 7.70828 8.33203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417 13.332H12.2917C11.4874 13.332 10.8333 13.9862 10.8333 14.7905V18.5405C10.8333 19.3446 11.4874 19.9987 12.2917 19.9987H18.5417C19.3458 19.9987 20 19.3446 20 18.5405V14.7905C20 13.9862 19.3458 13.332 18.5417 13.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5417 0H12.2917C11.4874 0 10.8333 0.654144 10.8333 1.45828V10.2083C10.8333 11.0126 11.4874 11.6667 12.2917 11.6667H18.5417C19.3458 11.6667 20 11.0126 20 10.2083V1.45828C20 0.654144 19.3458 0 18.5417 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_2647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardu);
export default __webpack_public_path__ + "static/media/dashboardu.84c106c635f8756b92f40b07c3180302.svg";
export { ForwardRef as ReactComponent };